import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: false,
    resourceName: 'card',
    routerUrl: '/card',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Card')),
    children: [
      //$MORE$
    ],
  },
];
